export const POPUP_DOM_ID = 'popup-root'

interface IGetRootParams {
  rootNode?: ShadowRoot | Document
  containerParent?: HTMLElement
  subAppClass?: string
}

export const getRoot = ({
  rootNode = document,
  containerParent = document.body,
  subAppClass,
}: IGetRootParams = {}) => {
  const popupRoot = rootNode.querySelector(`#${POPUP_DOM_ID}`) ?? createPopupRoot(containerParent)

  if (!subAppClass) {
    return popupRoot
  }

  return popupRoot.querySelector(`.${subAppClass}`) ?? createSubAppRoot(popupRoot, subAppClass)
}

const createPopupRoot = (containerParent: HTMLElement) => {
  const root = document.createElement('div')
  root.id = POPUP_DOM_ID
  containerParent.prepend(root)
  return root
}

const createSubAppRoot = (parent: Element, subAppClass: string) => {
  const subAppRoot = document.createElement('div')
  subAppRoot.className = subAppClass
  parent.appendChild(subAppRoot)
  return subAppRoot
}
